export class StackFrame {
  constructor(
    private readonly id: number,
    private readonly className: string | null,
    private readonly method: string,
    private readonly line: number | null,
    private readonly file: string | null
  ) {}

  getId() {
    return this.id;
  }

  getClassName() {
    return this.className;
  }

  getMethod() {
    return this.method;
  }

  getLine() {
    return this.line;
  }

  getFile() {
    return this.file;
  }

  getFullMethodName() {
    const className = this.getClassName();
    const method = this.getMethod();
    if (className) return `${className}.${method}`;
    if (method !== '<unknown>') return method;
    return null;
  }

  getFullFileName() {
    const file = this.getFile();
    const line = this.getLine();
    if (file && line) return `${file}:${line}`;
    if (file) return file;
    if (line) return `${line}`;
    return null;
  }
}
